import Service from './Service'
import { STATISTICS } from './apiUrls'

export default class StatisticService extends Service {
  getSellerData (query) {
    return this.axios.get(`${STATISTICS}/seller`, {params: query})
  }
  getSaleData (query) {
    return this.axios.get(`${STATISTICS}/sale`, {params: query})
  }
  getRdvData (query) {
    return this.axios.get(`${STATISTICS}/rdv`, {params: query})
  }
}



// WEBPACK FOOTER //
// ./src/services/api/StatisticService.js